import React from 'react';
import { Layout } from 'antd';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import Services from '../components/Services';
import AboutSection from '../components/AboutSection';
import Testimonials from '../components/Testimonials';
import ContactBanner from '../components/ContactBanner';
import Footer from '../components/Footer';

const { Content } = Layout;

const Home = () => {
  return (
    <Layout className="layout">
      <Header />
      <Content style={{ padding: '0 50px' }}>
        <HeroSection />
        <Services />
        <AboutSection />
        <Testimonials />
        <ContactBanner />
      </Content>
      <Footer />
    </Layout>
  );
};

export default Home;